<template>
  <FixedHeader>
    <div class="back-to-top">
      <button
        class="back-to-top-inner"
        @click="backToTop"
      >
        <up-icon class="back-to-top-icon caret-icon" />
        <div class="back-to-top-text uppercase">back to top</div>
      </button>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="0"
        height="0"
        viewBox="0 0 234 212"
      >
        <defs>
          <!-- precompute transform to be 1/234 & 1/214 -->
          <clipPath
            id="uglyScrollToTop"
            clipPathUnits="objectBoundingBox"
            transform="scale(0.004273504273504, 0.004672897196262)"
          >
            <path
              d="M 71 21.480 C 50.509 24.340, 37.249 31.823, 35.423 41.559 C 34.493 46.518, 36.806 54.033, 41.139 60.122 C 56.049 81.080, 56.846 101.169, 43.425 117.701 C 40.389 121.441, 37.356 125.175, 36.683 126 C 27.594 137.156, 23.805 145.223, 23.856 153.313 C 23.899 160.144, 25.636 164.595, 30.903 171.369 C 39.170 182.004, 59.853 191.568, 83.500 195.691 C 97.481 198.129, 133.388 198.109, 147.494 195.656 C 158.989 193.657, 170.799 190.749, 179.469 187.782 C 194.119 182.769, 213.122 171.291, 225.041 160.256 L 232.018 153.796 231.759 102.729 L 231.500 51.662 228.500 49.846 C 226.850 48.847, 224.600 47.619, 223.500 47.116 C 222.400 46.614, 218.125 44.638, 214 42.726 C 196.724 34.717, 156.948 24.500, 135.124 22.467 C 131.617 22.140, 127.342 21.644, 125.624 21.365 C 118.021 20.129, 80.109 20.208, 71 21.480 "
              stroke="black"
              fill="none"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  </FixedHeader>
</template>

<script>
import FixedHeader from 'vue-fixed-header';
import UpIcon from '@/assets/icons/circled-chevron-up.svg';

export default {
  components: {
    FixedHeader,
    UpIcon,
  },
  methods: {
    backToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.back-to-top {
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 2, 0.6));
  position: fixed;
  right: 0;
  top: 250px;

  &.vue-fixed-header {
    touch-action: none;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s linear;

    &--isFixed {
      touch-action: initial;
      pointer-events: initial;
      opacity: 1;
    }
  }

  &-inner {
    z-index: 110;
    color: white;
    @include theme-value(background, brand-color-one);
    width: 9em;
    border: none;
    font-weight: 600;

    .tastecard & {
      border-radius: 1em;
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
      clip-path: url(#uglyScrollToTop);
    }

    .gourmet-society & {
      clip-path: initial;
      border-radius: 0;
    }

    &:focus {
      // 😢
      outline: none;
    }
  }

  &-icon {
    margin: {
      top: 1em;
    }
  }

  &-text {
    margin: {
      bottom: 1em;
      right: 1em;
      left: 1.5em;
    }
  }
}

.uppercase {
  text-transform: uppercase;
}

.caret-icon {
  width: 1.5em;
  height: 1.5em;
  margin-bottom: 0.2em;
}
</style>
